import { z } from 'zod/v3';

const key = z.string().min(1).nullable();
const bands = z.object({ low: key, base: key, high: key });
const option = z.object({
  optionRef: z.string(), label: z.string(), commitmentLabel: z.string(),
  effectMonth: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/).nullable(),
  selection: z.string(), selected: z.boolean(), assumption: z.string().nullable(),
  deltaKey: key, annualKey: key, costKey: key,
  /** Published gap before this option and the gap still open with it; older frames omit both. */
  gapKey: key.optional(), residualKey: key.optional(),
  sourceBands: z.object({ annual: bands, cost: bands, monthsKey: key }).optional(),
});
const profiles = z.array(z.object({
  ref: z.string(), label: z.string(), isDefault: z.boolean(),
  selectedOptionRef: key, residualKey: key, deltaKey: key, options: z.array(option),
  structuralTiming: z.string().optional(),
}));

/** Optional presentation; money remains in the stage's existing numeric bindings. */
export type SynergyLoopRecoveryProfile = z.infer<typeof profiles>[number];
export function readSynergyLoopRecovery(value: unknown): readonly SynergyLoopRecoveryProfile[] | null {
  const parsed = profiles.safeParse(value);
  return parsed.success ? parsed.data : null;
}
